/* bespoke code for zenb bundles */
var zenb_bundle_admin = {};

//zenb_bundle_admin.bundle_handle_flag = 'pickandmix';
zenb_bundle_admin.bundle_handle_flag = 'subscription';

//console.log(zenb_bundle_admin.bundle_handle_flag)

zenb_bundle_admin.addProductDetails = function(data,callback){
  /* this func is called from recharge theme > _utils.js : addProductDetailsHandler */
  //console.log("[zenb_bundle_admin : DS::bundles-line-items]");

  var product_handle = data.products[0].handle;
  zenb_bundle_admin.getBundleProduct(product_handle);

  /* we check the data to see if we are looking at a pick n mix product */
  //if(data && data.products[0].handle == "pickandmixsubscription" ){
  if(data && data.products[0].handle.indexOf(zenb_bundle_admin.bundle_handle_flag) != -1){
    console.log("pick n mix");
    console.log(data);
    //Do we have all our items (probably not as recharge doesn't pass these?!)
    if(false){
      //yes: pass on the next step...
      callback(data);
    }else{
      //no: we need a popup that lets us pick our sub-items
      zenb_bundle_admin.openBundleOptions(data,callback);
    }
  }else{
    /* Its a normal product */
    console.log(data);
    console.log("do the callback");
    callback(data);
  }
  

}

zenb_bundle_admin.addUpsellProduct = function(data,chosenProduct,callback){
  //add from the upsell panel

  $('body').addClass('active-popup-full');

  console.log('addUpsellProduct');
  var product_handle = chosenProduct.handle;
  zenb_bundle_admin.getBundleProduct(product_handle);

 // if(chosenProduct && chosenProduct.handle == "pickandmixsubscription" ){
  if(chosenProduct && chosenProduct.handle.indexOf(zenb_bundle_admin.bundle_handle_flag) != -1){

    //FOR this mode we can just add the properties directly to the main data object.

    if(false){
      //yes: pass on the next step...
      callback(data);
    }else{
      //no: we need a popup that lets us pick our sub-items
      zenb_bundle_admin.openBundleOptions(data,callback);

    }

    //example of the title list
    var bundleItemProperties = '';
     if($(".bundle-item-properties").val()) bundleItemProperties = $(".bundle-item-properties").val();
    data["properties[Contains]"] = bundleItemProperties;
    //data["properties[Contains]"] = "5x ZENB Fusilli Pasta, 5x ZENB Roasted Red Pepper Sauce 250g";
    
    console.log(data["properties[Contains]"] = bundleItemProperties);

    var countProperties = 1;
    $('.line-items .individual-items').each(function(i){
      var val = $(this).val();
      var name =  $(this).attr("name");
      //var  itemVal = 'data["' +[name] + '"]' + '="' + val +'"';
      data["properties[Contains-"+ countProperties +"]"] = val;
      console.log(data["properties[Contains-"+ countProperties +"]"] = val);
      countProperties ++;

    });

    if(bundleItemProperties == "") {
      return false;
    }
    else {
      console.log("Callback Ready");
       callback(data);
    }
    
    //return false
    //console.log(data["properties[Contains-1]"])
    //if(bundleItemProperties == '') { return false };
  //  else {   alert("Calback ready"); return false}
    
    //then we can pass this back
    callback(data);
  }else{
    callback(data);
  }
}

zenb_bundle_admin.swapProductDetails = function(swap_product,callback){
      //Swap action 

      var product_handle = swap_product.handle;
      zenb_bundle_admin.getBundleProduct(product_handle);
      
      //if(swap_product && swap_product.handle == "pickandmixsubscription" ){
      if(swap_product && swap_product.handle.indexOf(zenb_bundle_admin.bundle_handle_flag) != -1){
        console.log("pick n mix swap");
        console.log(swap_product);

        //build a product array to pass to our function
        var data = {};
        data.products = [swap_product];

         if(false){
            //yes: pass on the next step...
            callback(data);
          }else{
            //no: we need a popup that lets us pick our sub-items
            zenb_bundle_admin.openBundleOptions(data,callback);
          }
          
        //zenb_bundle_admin.openBundleOptions(data,callback);
        //callback();
      }else{
        /* Its a normal product */
        //console.log("do the callback");
        //console.log(swap_product);
        callback();
      }
}

zenb_bundle_admin.openBundleOptions = function(data,callback){
  //open a popup where we can pick our 10 items

    //contains property is a list of the product titles : properties[Contains] "1x ZENB Cherry Tomato Sauce 250g, 1x ZENB Fusilli Pasta"
    //format of line items: properties[contains-1] = "830-10002"

    //1) pull out the product
    //let product = data.products[0];
    let product = zenb_bundle_admin.bundle_handle_flag;

    //2) if we wanted to make edits to the products we could do that here.
  
    //3) push back

    //data.products[0] = product; //we dont actually do anything with the data here (we add hidden fields to the form. see below)

    //4) launch popup with options
    var bundle_popup_id = "bundle_popup";
    zenb_bundle_admin.bundleOptionsPopup(bundle_popup_id,bundle_popup_finish);
  
    function bundle_popup_finish(){
      //5) the callback adds our product to the sidebar  
      callback(data);
  
      //6) //take the options from our popup
      var items_list = [];
      let $popup = $('#'+bundle_popup_id);

      //
      /*items_list[0] = $popup.find('.list').value();
      for(n=1;n<=10;n++){
        items_list[n] = $popup.find('.sku'+n).value();
      }*/
      
      
      zenb_bundle_admin.injectBundleProductItems(items_list);
    }  

}

zenb_bundle_admin.popup_html = `<div class='bundle-admin-popup'>
                                <span class="close-bundle-popup">X</span>
                                <div class='bundle-admin-popup-content'>
                                <img class="popup-loader-img" src='https://cdn.shopify.com/s/files/1/0319/8101/1003/files/ajax-loader.gif?v=1676626796'>
                                 </div>
                                  <button class='js-popup-finish rc_btn border-light text-uppercase title-bold' disabled="disabled">COMPLETE YOU BOX</button>
                               </div>`;

zenb_bundle_admin.bundleOptionsPopup = function(bundle_popup_id,bundle_popup_finish_callback){
  
  //created a form
  if($('.bundle-admin-popup').length == 0){
    $( "#recharge-te" ).append( $( zenb_bundle_admin.popup_html ) );
    $('body').addClass('bundle-admin-popup-wrapper');
    $('.view-product-button').attr('disabled', true);
  }else{
    $('.bundle-admin-popup').show();

  }
   

   // close bundle product popup action  
  $('.close-bundle-popup').click(function(){
    $('body').removeClass('bundle-admin-popup-wrapper');
    $('body').removeClass('active-popup-full');
    $('.rc_upsells-btns .pix-mix-btn').attr('disabled', false);
    $('.rc_upsells-btns .pix-mix-btn').val("Add subscription");
    
  }) 
  $('.close-sidebar, .close-bundle-popup').click(function(){
    $('.bundle-admin-popup').remove();
    $('.view-product-button').attr('disabled', false);
    $('.bundle-item-properties').remove();
  }) 

  //submit success runs the callback
  $('.js-popup-finish').click(function(){

   if (!$('.mydivclass').length > 0) { 
    $('.js-pix-mix-btn .pix-mix-btn').attr('disabled', false);
    $('.js-pix-mix-btn .pix-mix-btn').trigger("click");
  }

    $('body').removeClass('bundle-admin-popup-wrapper');
    $('.view-product-button').attr('disabled', false);
      setTimeout(function() {
        var bundleItemProperties = $(".bundle-item-properties").val();
        $("<div class='bundle-pr-item' >" + bundleItemProperties +"</div><br>").insertAfter( $( ".element__flex-column"));
      }, 1000);
      setTimeout(function() {
        $('.bundle-admin-popup').remove();
       }, 1010);

      if (!$('.js-pix-mix-btn .pix-mix-btn').length > 0) {
        bundle_popup_finish_callback();
      }
  });
  
}
zenb_bundle_admin.injectBundleProductItems = function(items_list) {
    //add our own custom data to the form ( see _subscriptions.js for ref )
    productContainer = document.querySelector('.rc_add_product_details_container');  
    productContainerSwap = document.querySelector('.rc_swap_product_details_container');  

    //TODO: take the array list of products and add this to the productContainer (example data below)
    
    //EXAMPLE: example dynamic coded data...
    if ($(".rc_add_product_details_container").length > 0){
      productContainer.innerHTML  += $(".line-items" ).html();
    }
    if ($(".rc_swap_product_details_container").length > 0){
      productContainerSwap.innerHTML  += $(".line-items" ).html();
    }
}

zenb_bundle_admin.addBundleProduct = function(items_list) {
  /*
  Example code for adding a new subscription
  */
  $.ajax({
    url: "{{ subscription_list_url }}",
    type: "post",
    dataType: "json",
    data: {
      shopify_variant_id: "5423555936320",
      order_interval_frequency: "1",
      order_interval_unit: "month",
      charge_interval_frequency: 1,
      next_charge_scheduled_at: "2019-12-26",
      address_id: 32172754,
      quantity: 1,
      "properties[key-prop]": "value-prop",
    },
  })
  .done(function (response) {
    // Successful request made
    console.log(response);
  })
  .fail(function (response) {
    // Request failed
    console.log(response);
  });
}

//Get the bundle product in Popup

zenb_bundle_admin.getBundleProduct = function(handle) {
  var product_handle = handle;
  var url = 'https://zenb.co.uk/pages/bundle-feed/' + product_handle;
  $.ajax({
    url: url,
    type: "get"
  })
  .done(function (data) {
    // Successful request made

    /*result = $(data).find(".recharge-bunlde-product-popup");
    if(!result == ''){
      $(".bundle-admin-popup .bundle-admin-popup-content ").html(data);
    }*/
    
    $(".bundle-admin-popup .bundle-admin-popup-content ").html(data);
    return true;

    //var data = jQuery.parseJSON(data);
    console.log('success');

  })
  .fail(function (data) {
    // Request failed
    console.log(fail);
  });
}



